import { Injectable } from "@angular/core"
import { Constants } from "config/constants"
const ENV = Constants.ENV

declare let ym: Function
const metrikaId: number = 84476008

@Injectable()
export class YandexMetrikaService {

  public reachGoal(target: string, params: Object = {}) {
    console.log("reachGoal:", target, params)

    if (ENV.isProduction) {
      ym(metrikaId, 'reachGoal', target, params)
    }
  }

  public hit(url: string, params: Object = {}) {
    console.log("hit:", url, params)

    if (ENV.isProduction) {
      ym(metrikaId, 'hit', url, params);
    }
  }

  public setUserId(userId: string) {
    console.log("setUserId:", userId)

    if (ENV.isProduction) {
      ym(metrikaId, 'setUserID', userId)
    }
  }

  public userParams(params: Object) {
    console.log("userParams:", params)
    
    if (ENV.isProduction) {
      ym(metrikaId, 'userParams', params)
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/pages/admin/yandex-metrika.service.ts